
<div class="checkbox-container" [class.disabled]="isDisabled" (click)="onCheckboxChange()">
  <input type="checkbox" [checked]="isChecked" [disabled]="isDisabled" hidden>
  <div class="checkbox" [class.checked]="isChecked">
    <img *ngIf="isChecked" src="../../../../../assets/icons/check-icon.svg" class="check-icon" />
  </div>
  <span class="checkbox-label">{{ label }}</span>
</div>
